import { Component } from 'react';
import { withRouter } from 'react-router';

const SITE_NAME = 'Columbus Water Works';

const ADMIN_TITLE_MAP = {
    '/AdminHome': 'Admin Dashboard',
    '/PageComponentManagement': 'Page Management',
    '/CreatePage': 'Create Page',
    '/UpdatePage': 'Update Page',
    '/CreateExternalPage': 'Create External Page',
    '/UpdateExternalPage': 'Update External Page',
    '/UpdatePageComponent': 'Page Components',
    '/Settings': 'Settings',
    '/LayoutManagement': 'Site Information',
    '/FormBuilderManagement': 'Form Builder',
    '/CreateForm': 'Create Form',
    '/FormBuilder': 'Form Builder',
    '/FormBuilderSubmissions': 'Form Submissions',
    '/FormBuilderSingleSubmission': 'Submission Details',
    '/TracSoftSettings': 'TracSoft Settings',
    '/PagePreview': 'Page Preview',
    '/UserManagement': 'User Management',
    '/CreateUser': 'Create User',
    '/UpdateUser': 'Update User',
    '/RoleManagement': 'Role Management',
    '/DocumentManagement': 'Document Management',
    '/DocumentDeletion': 'Document Deletion',
    '/CreateDocument': 'Create Document',
    '/UpdateDocument': 'Update Document',
    '/EventManagement': 'Event Management',
    '/EventDeletion': 'Event Deletion',
    '/CreateEvent': 'Create Event',
    '/UpdateEvent': 'Update Event',
    '/BlogManagement': 'Blog Management',
    '/CreateBlog': 'Create Blog',
    '/UpdateBlog': 'Update Blog',
    '/PreviewBlog': 'Preview Blog',
    '/NewsManagement': 'News Management',
    '/CreateNews': 'Create News',
    '/UpdateNews': 'Update News',
    '/BirthdayManagement': 'Birthday Management',
    '/ImageManagement': 'Image Management',
    '/ImageDeletion': 'Image Deletion',
    '/SideNavManagement': 'Side Nav Management',
    '/CreateSideNav': 'Create Side Nav',
    '/UpdateSideNav': 'Update Side Nav',
    '/Login': 'Login'
};

class RouteChangeHandler extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // Move focus to main content area on route change
            let mainContent = document.getElementById('main-content');
            if (mainContent) {
                mainContent.focus();
                window.scrollTo(0, 0);
            }
            this.updatePageTitle(this.props.location.pathname);
        }
    }

    updatePageTitle(pathname) {
        let title = null;
        for (let route in ADMIN_TITLE_MAP) {
            if (pathname === route || pathname.startsWith(route + '/')) {
                title = ADMIN_TITLE_MAP[route];
                break;
            }
        }

        if (title) {
            document.title = title + ' - ' + SITE_NAME;
        } else if (pathname === '/') {
            document.title = SITE_NAME;
        }
        // Public pages: Pages.js and Blog.js use MetaTags to set title from API data
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(RouteChangeHandler);
